/**
 * โซนและประตูเชื่อมโซน — กฎกลางที่ทั้งสองฝั่งใช้
 *
 * server ใช้ตัดสินว่าผู้เล่นยืนที่ประตูจริงไหม และจะไปโผล่ที่ไหน
 * client ใช้วาดประตูและรู้ว่าเดินเข้าประตูแล้วหรือยัง (แค่เพื่อส่งคำขอ server ตัดสินเอง)
 *
 * pure function ทั้งหมด
 */
import { ZONES } from "./data.js";
/**
 * ยืนห่างจุดกลางประตูไม่เกินเท่านี้ถือว่าเข้าประตู
 *
 * กว้างพอให้เดินผ่านแล้วติด ไม่ต้องเล็งเป๊ะ แต่ไม่กว้างจนเฉียดแล้ววาร์ปโดยไม่ตั้งใจ
 */
export const PORTAL_RADIUS = 3;
/**
 * โผล่ห่างจากประตูปลายทางเข้ามาในแผนที่เท่านี้
 *
 * ต้องพ้นรัศมีประตู ไม่งั้นโผล่มาปุ๊บก็ยืนอยู่ในประตูอีกฝั่ง แล้ววาร์ปกลับวนไปมา
 */
export const PORTAL_ARRIVE_GAP = PORTAL_RADIUS + 2.5;
/** ประตู `id` ในโซนนี้ */
export function findPortal(zone, id) {
    return zone?.portals?.find((p) => p.id === id);
}
/** ยืนอยู่ในประตูไหน (ถ้ามี) */
export function portalAt(zone, x, z) {
    return zone?.portals?.find((p) => Math.hypot(p.x - x, p.z - z) <= PORTAL_RADIUS);
}
/**
 * จุดที่โผล่เมื่อเดินผ่านประตูนี้ไปโซนปลายทาง
 *
 * ขยับจากประตูปลายทางเข้าหาจุดเกิดของโซนนั้น `PORTAL_ARRIVE_GAP` หน่วย
 * จึงโผล่หันหน้าเข้าแผนที่เสมอ ไม่ต้องกำหนดทิศเองทีละประตู
 */
export function arrivalPoint(portal) {
    const dest = ZONES[portal.to];
    const exit = findPortal(dest, portal.toPortal);
    if (!dest || !exit)
        return undefined;
    const dx = dest.spawnPoint.x - exit.x;
    const dz = dest.spawnPoint.z - exit.z;
    const d = Math.hypot(dx, dz) || 1;
    return {
        zone: dest.id,
        x: exit.x + (dx / d) * PORTAL_ARRIVE_GAP,
        z: exit.z + (dz / d) * PORTAL_ARRIVE_GAP,
    };
}
/** โซนเมืองแรก ใช้เป็นที่กลับเมื่อเลือก "กลับจุดตะเกียง" ตอนตายนอกเมือง */
export function townZoneId() {
    return Object.values(ZONES).find((z) => z.town)?.id ?? "meadow";
}
//# sourceMappingURL=zones.js.map